module.exports = __webpack_public_path__ + "images/modules/boat-explorer/line-8.png";


//////////////////
// WEBPACK FOOTER
// ./images/modules/boat-explorer/line-8.png
// module id = 59
// module chunks = 0